<template>

  <div id="app">
    <el-container class="flextext">
      <home-head></home-head>
      <el-main class="neitong_bufen_qiangzhi">
        <div class="content">
          <el-tag closable v-if="js_zhi" @close="juese_sc_sj()">{{js_zhi.title}}</el-tag>
          <el-tag closable v-if="bujian" @close="bujian_sc_sj()" style="margin-left: 20px">{{bujian}}</el-tag>
          <el-tag closable v-if="ly_zhi" @close="lingyu_sc_sj()" style="margin-left: 20px">{{ly_zhi.title}}</el-tag>
          <div class="main-heads">
            <div style="width: 95%; margin: 0 auto;position: relative">
              <div v-if="aa==1">
                <i class="el-icon-arrow-down" style="position: absolute;left: 100%;top: 25px;font-size: 16px"
                   @click="xiaoxi(aa=2)"></i>
                <div class="search-tops">应用领域：</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly.slice(0,12)" :key="index">
                    <a class="a_color" @click="lingyu_sj(item1)" :title="item1.title">
                      <div class="search-tops-title" id="showLabelAndAttrName"> {{ item1.title }}</div>
                    </a>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div style="width: 95%; margin: 0 auto;position: relative">
              <div v-if="aa==2">
                <i class="el-icon-arrow-down" style="position: absolute;left: 100%;top: 25px;font-size: 16px"
                   @click="xiaoxi(aa=1)"></i>
                <div class="search-tops">应用领域：</div>
                <el-row class="search_tops_el_row">
                  <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly" :key="index">
                    <a class="a_color" @click="lingyu_sj(item1)" :title="item1.title">
                      <div class="search-tops-title" id="showLabelAndAttrName"> {{ item1.title }}</div>
                    </a>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="main-head">
            <el-row>

              <el-col :xs="8" :sm="6" :md="4" style="width: 300px">
                <div class="search-top">区域：
                  <el-cascader class="jilian_xuanzeqi_wenzi_yangshi"
                               size="mini"
                               :options="options"
                               v-model="selectedOptions"
                               popper-class="dingdanchuangjian_xuanzhong_lika_qiangzhi_tihuan2"
                               @change="handleChange">

                  </el-cascader>

                </div>
              </el-col>
              <el-col :xs="8" :sm="6" :md="4" >
                <div class="shangpin_sousou">
                <el-input style="margin-top: 2px;
                                 border: 1px solid #c60000;border-radius: 5px;width:135px;"
                          size="mini"
                          placeholder="请输入内容"
                          v-model="input2"
                          >
                </el-input>
                <el-button type="danger"
                           size="mini"
                           style="position: relative;left: -5px;height: 30px;width: 60px;"
                           @click="input_sj(input2)" >搜索
                </el-button>
                </div>
<!--                <a @click="input_sj(input2)" class="search-logo">-->
<!--                  <img src="../../../assets/home/sousuo_logo.png" style="position: absolute;left: 410px;top:24px">-->
<!--                </a>-->
              </el-col>

            </el-row>
          </div>


          <el-row :gutter="10" style="margin-top: 20px;">
            <el-col :xs="12" :sm="12" :md="6" v-for="(item,index) in list" :key="index">
              <div class="shebei-item">
                <a v-if="item.api_edition == 2202" v-bind:href="'#/dianpu_new/' + item.id ">
                  <div class="backgd">
                    <el-image :src="url+'/storage/'+item.cover" fit="cover" style="position: relative">
                      <div slot="error" class="image-slot">
                        <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt="" style="height: 220px">
                      </div>
                    </el-image>
                    <div class="erhsoushangpin">二手商品</div>
                  </div>
                  <div style="width: 100%;height: 21px">
                    <p style="text-align: center;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#404040">{{item.title}}</p>
                  </div>
                  <div style="text-align: center">
                    <span class="priceses" v-if="item.cash==0.00">价格
                      <span class="money">¥</span><span class="value">面议</span>
                    </span>
                    <span class="priceses" v-else>价格
                      <span class="money">¥</span><span class="value">{{item.cash}}</span>
                  </span>
                  </div>
                </a>
                <a v-else v-bind:href="'#/dianpu_index/' + item.id ">
                  <div class="backgd">
                    <!--                    <div class="erhsoushangpin">最新商品</div>-->
                    <el-image :src="url+'/storage/'+item.cover" fit="cover" style="position: relative">
                      <div slot="error" class="image-slot">
                        <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png" alt=""
                             style="height: 220px">
                        <!--                        <i class="el-icon-picture-outline"></i>-->
                      </div>
                    </el-image>
                    <div class="erhsoushangpin">二手商品</div>
                  </div>
                  <div style="width: 100%;height: 21px">
                    <p style="text-align: center;font-size:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#404040">{{item.title}}</p>
                  </div>
                  <!--                    <div class="good">好评121&nbsp;162人购买</div>-->
                  <div style="text-align: center">
                    <span class="priceses" v-if="item.price_yugu==0.00">明码标价
                      <span class="money">¥</span><span class="value">{{item.cash}}</span>
                    </span>
                    <span class="priceses" v-else>预估价格
                      <span class="money">¥</span><span class="value">{{item.price_yugu}}</span>
                  </span>
                  </div>
                </a>
              </div>
            </el-col>
          </el-row>


          <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
               style="line-height: 5.1em;margin-top: 60px">
            <div data-v-6af373ef="" class="el-pagination is-background">
              <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
              <el-pagination
                      style="float: left"
                      layout="prev, pager, next"
                      @current-change="yedianji"
                      :total="zuidayema*10">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-main>


      <footerall></footerall>
    </el-container>
  </div>
</template>
<script>
    import home_head from '../../common/home-head';
    import {regionDataPlus} from 'element-china-area-data'
    import footerall from "../../common/footer";

    export default {

        name: "category",
// /storage/

        data: function () {
            return {
                fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                    phone_shaixuan: 0,
                    phone_sousuokuang: 0,
                },
                input2: '',
                options: regionDataPlus,
                selectedOptions: [],
                list: '',
                lists: '',
                list_guige: [],
                url: '',
                zuoshuL: '',
                zuidayema: '',
                diqu: '',
                is_open2: 1,
                is_open3: 1,
                checked: false,
                aaa: true,
                pidzhi: 0,
                gongyelian: '',
                lingbujian: '',
                bujian: '',
                gylian: '',
                biaoqain_name: '',
                yingyong_ly: '',
                ly_zhi: '',
                js_zhi: '',
                information: '',
                qy_juese: '',
                aa: '1'
            }
        },
        components: {
            'home-head': home_head,
            footerall
        },
        methods: {
            xiaoxi(aa) {
                console.log(aa)
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)
            },
            init() {
                this.information = this.$store.state.information
                this.list_data()
                this.list_price()
                this.gy_lian()
                this.lingyu()
                this.gj_bujian()
                this.juese()
                this.url = window.config.api_url
            },
            input_sj(e) {
                var t = this
                t.input2 = e
                t.list_data()
            },
            list_price() {
                var t = this
                var url = window.config.api_url + '/college/goods/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.lists = res.data
                    res.data.specification.forEach(function (item) {
                        t.list_guige.push({
                            estimate: item.estimate,
                            goods_id: item.goods_id,
                            id: item.id,
                            price: item.price,
                            specification: item.specification,
                            sum: 0
                        })
                    })
                    t.dp_inform()
                })
            },
            juese() {
                var t = this
                var url = window.config.api_url + '/college/job'
                t.axios.get(url).then(res => {
                    t.qy_juese = res.data
                })
            },
            lingyu() {
              var t = this
              var url = window.config.api_url + '/college/subject/tree'
              t.axios.get(url).then(res => {
                t.yingyong_ly = res.data
              })
            },
            gj_bujian() {
                var t = this
                var url = window.config.api_url + '/college/goods/parts'
                t.axios.get(url).then(res => {
                    t.lingbujian = res.data
                })
            },
            gy_lian() {
                var t = this
                var url = window.config.api_url + '/college/goods/chain'
                t.axios.get(url).then(res => {
                    t.gongyelian = res.data
                })
            },
            lingyu_sj(e) {
                var t = this
                t.ly_zhi = e
                t.list_data()
            },
            juese_sj(e) {
                var t = this
                t.js_zhi = e
                t.list_data()
            },
            bujian_sj(e) {
                var t = this
                t.bujian = e
                t.list_data()
            },
            biaoqian_sc_sj() {
                var t = this
                t.pidzhi = 0
                t.fl_get()
                t.list_data()
            },
            lingyu_sc_sj() {
                var t = this
                t.ly_zhi = ''
                t.list_data()
            },
            juese_sc_sj() {
                var t = this
                t.js_zhi = ''
                t.list_data()
            },
            bujian_sc_sj() {
                var t = this
                t.bujian = ''
                t.gj_bujian()
                t.list_data()
            },
            fl_get(e) {
                var t = this
                if (e) {
                    t.pidzhi = e.id
                    t.biaoqain_name = e.name
                }
                var url = window.config.api_url + '/college/goods/cate?pid=' + t.pidzhi
                t.axios.get(url).then(res => {
                    if (res.data == '') {
                        return console.log(res.data, 908)
                    }
                    t.qy_juese = res.data
                })
                if (e) {
                    t.list_data()
                }
            },
            list_data(e) {
                var t = this
                var url = window.config.api_url + '/college/second/hand/list'
                if (e) {
                    url += '?paginate=12&page=' + e
                } else {
                    url += '?paginate=12&page=1'
                }
                if (t.diqu) {
                    url += '&province=' + t.diqu[0]
                    if (t.diqu[1]) {
                        url += '&city=' + t.diqu[1]
                    }
                    if (t.diqu[2]) {
                        url += '&area=' + t.diqu[2]
                    }
                }
                if (t.bujian) {
                    url += '&parts=' + t.bujian
                }
                if (t.is_open2 == 0) {
                    url += '&order=cash'
                }
                if (t.is_open3 == 0) {
                    url += '&by=desc'
                }
                if (t.is_open3 == 1) {
                    url += '&by=asc'
                }
                if (t.checked == true) {
                    url += '&has_price=1'
                }
                if (t.aaa == true) {
                    url += '&cate_id=168'
                }
                if (t.pidzhi != 0) {
                    url += '&cate_id=' + t.pidzhi
                }
                if (t.ly_zhi) {
                    url += '&aac_id=' + t.ly_zhi.id
                }
                if (t.js_zhi) {
                    url += '&aac_id=' + t.js_zhi.id
                }
                if (t.input2) {
                    url += '&title=' + t.input2
                }
                t.axios.get(url).then(res => {
                    t.list = res.data.data
                    t.zuoshuL = res.data.total
                    t.zuidayema = res.data.last_page
                })
            },
            mm_biaojia() {
                var t = this
                t.list_data()
            },
            px_shijian() {
                var t = this
                if (t.is_open2 == 1) {
                    t.is_open2 = 0
                } else {
                    t.is_open2 = 1
                }
                t.list_data()
            },
            px_shijian2() {
                var t = this
                if (t.is_open3 == 1) {
                    t.is_open3 = 0
                } else {
                    t.is_open3 = 1
                }
                t.list_data()
            },
            handleChange(value) {
                this.diqu = value
                this.list_data()
            },
            yedianji(e) {
                this.list_data(e)
            }
        },
        created() {
            this.init()
        }
    }
</script>
<style>

  .neitong_bufen_qiangzhi .el-tag--light {
    background-color: #4E6EF2 !important;
    color: #FFFFFF !important;
  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #4E6EF2;

  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4E6EF2;
  }

  .el-checkbox__inner {
    margin-left: -15px;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__inner:hover {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4E6EF2 !important;
    border-color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down {
    font-size: 0px !important;
    color: #666666 !important;
  }

  .jilian_xuanzeqi_wenzi_yangshi {
    font-size: 18px !important;

  }

  .neitong_bufen_qiangzhi .el-input__inner {
    border: 0px !important;
  }

  .neitong_bufen_qiangzhi .el-tag {
    text-align: center;
    width: 120px;
    margin-top: 20px;
    padding: 0;
    height: 24px;
    line-height: 24px;
    margin-left: 2.5% !important;
  }

  .el-checkbox__label {
    font-size: 18px !important;
  }

  .el-checkbox {

    font-size: 18px !important;
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

  @head_text: Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  @import "../../../assets/css/home_second_goods";
  .flextext {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;

  }
.shangpin_sousou{
  width: 430px;
}
</style>
